import createTableStore from "ds/components/Table/store/useTableStore";

import {
  SPACELIFT_VCS_REPO_USED_BY_TABLE_COLUMNS_CONFIG,
  SPACELIFT_VCS_REPO_USED_BY_TABLE_STORAGE_KEY,
} from "./constants";

const useSpaceliftVcsRepoUsedByTableStore = createTableStore({
  storageKey: SPACELIFT_VCS_REPO_USED_BY_TABLE_STORAGE_KEY,
  config: SPACELIFT_VCS_REPO_USED_BY_TABLE_COLUMNS_CONFIG,
});

export default useSpaceliftVcsRepoUsedByTableStore;
